<script setup lang="ts">
import { useI18n } from '@/shared/i18n'
import { Button } from '@/shared/ui/button'

defineProps<{ question: string; detail: string; confirmLabel: string }>()
const emit = defineEmits<{ keep: []; confirm: [] }>()

const { t } = useI18n()
</script>

<template>
  <div class="confirm-strip border-b border-subtle bg-danger-soft px-md py-sm last:border-0">
    <p class="m-0 text-xs font-semibold text-danger">{{ question }}</p>
    <p class="mt-2xs mb-0 text-xs text-muted">{{ detail }}</p>
    <div class="mt-xs flex items-center gap-xs">
      <Button variant="soft" size="xs" data-testid="confirm-keep" @click="emit('keep')">
        {{ t('insightActions.history.confirm.keep') }}
      </Button>
      <Button variant="primary" size="xs" data-testid="confirm-yes" @click="emit('confirm')">
        {{ confirmLabel }}
      </Button>
    </div>
  </div>
</template>
